import { makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'
import { green, shadowGreenColor } from '../../../../lib/Colors'

export default makeStyles(
	(theme: Theme) => ({
		textArea: {
			width: '100%',
			height: '200px',
			borderRadius: '6px',
			border: `1px solid ${shadowGreenColor}`,
			padding: '12px',
			fontSize: '14px',
			resize: 'none',
			marginTop: '16px',

			'&:focus': {
				outline: 'none',
				border: `1px solid ${green}`,
			},
		},
	}),
	{ index: 1 },
)
